// ============================================================================
// TENANT USER ROLE ENDPOINTS
// ============================================================================
// Endpoint definitions for assigning roles to tenant users.
// BASE_PATH matches the backend controller: TenantUserRoleController → /TenantUserRole

import { buildEndpoint, buildEndpointWithParams, buildEndpointWithQuery } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/TenantUserRole';

export const tenantUserRoleEndpoints = {
  /**
   * Roles currently assigned to a user in the tenant context
   * GET /TenantUserRole/user/:userId
   */
  getUserRoles: (userId: ID) => buildEndpointWithParams(`${BASE_PATH}/user/:userId`, { userId }),

  /**
   * Users holding a given role
   * GET /TenantUserRole/role/:roleId
   */
  getUsersWithRole: (roleId: ID) => buildEndpointWithParams(`${BASE_PATH}/role/:roleId`, { roleId }),

  /**
   * Does this user hold this role?
   * GET /TenantUserRole/check?userId&roleId
   */
  check: (userId: ID, roleId: ID) =>
    buildEndpointWithQuery(buildEndpoint(`${BASE_PATH}/check`), { userId, roleId }),

  /**
   * Assign a role
   * POST /TenantUserRole/assign
   */
  assign: () => buildEndpoint(`${BASE_PATH}/assign`),

  /**
   * Revoke by assignment id
   * DELETE /TenantUserRole/:id
   */
  revoke: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /**
   * Revoke by user + role instead of assignment id
   * DELETE /TenantUserRole/revoke?userId&roleId
   */
  revokeByDetails: (userId: ID, roleId: ID) =>
    buildEndpointWithQuery(buildEndpoint(`${BASE_PATH}/revoke`), { userId, roleId }),
} as const;

export default tenantUserRoleEndpoints;
